import { Logo } from 'assets/images'

import { SyncOutlined } from '@ant-design/icons'
import { useQueryClient } from '@tanstack/react-query'
import { Auth } from 'aws-amplify'
import StyledDropdown from 'components/Elements/StyledDropdown'
import { useDashTour } from 'sections/Dashboard/hooks'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useEffect, useState } from 'react'
import { Image, Nav, Navbar } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { FaBars } from 'react-icons/fa'
import { useMediaQuery } from 'react-responsive'
import { Link, matchPath, useLocation } from 'react-router-dom'
import { langs } from 'services'
import { HELP_DESK } from 'services/constants'
import { breakpoints, colors } from 'style'
import { TopbarContainer } from './style'

function Topbar() {
  const { pathname } = useLocation()
  const { t, i18n } = useTranslation()
  const queryClient = useQueryClient()
  const {
    lang,
    setLang,
    loggedInUser,
    setAuthUser,
    setLoggedInUser,
    isCheckingLogin,
  } = useContext(DataContext)
  const launchTour = useDashTour()
  const isMobile = useMediaQuery({
    query: `(max-width: ${breakpoints.sm}px)`,
  })
  const dashboardMatch = matchPath(pathname, {
    path: `/dashboard`,
  })
  const [expanded, setExpanded] = useState(false)

  const changeLang = (ln) => {
    i18n.changeLanguage(ln)
    setLang(ln)
    localStorage.setItem('locale', ln)
  }
  const signOut = () => {
    localStorage.clear()
    sessionStorage.clear()

    setAuthUser(null)
    setLoggedInUser(null)
    queryClient.invalidateQueries()
    Auth.signOut()
  }

  const showSpinner = isCheckingLogin && !loggedInUser

  const [scrollY, setScrollY] = useState({ position: 'relative' })

  useEffect(() => {
    window.addEventListener(
      'scroll',
      function (event) {
        if (!event.target.children[0]) return

        const rect = event.target.children[0].getBoundingClientRect()

        if (rect.top > -100 || null) {
          setScrollY({ position: 'relative' })
        } else {
          setScrollY({
            position: 'fixed',
            top: '0px',
            zIndex: '999',
            width: '100%',
            background: 'white',
          })
        }
      },
      true,
    )

    return () => {
      window.removeEventListener('scroll', null)
    }
  }, [])

  return (
    <TopbarContainer>
      <Navbar
        collapseOnSelect
        expand="md"
        className="topbar-top"
        expanded={expanded}
      >
        <div className="topbar-wrapper">
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => setExpanded(!expanded)}
          >
            <FaBars color={colors.black} size={24} />
          </Navbar.Toggle>
          <Link to="/" className="navbar-brand">
            <Image src={Logo} />
          </Link>
        </div>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ml-auto">
            {showSpinner ? (
              <div className="spinner-wrapper mr-2">
                <SyncOutlined spin />
              </div>
            ) : loggedInUser ? (
              <Link to="/" className="btn-nav" onClick={signOut}>
                {loggedInUser.first_name} ({t('sign_out')})
              </Link>
            ) : (
              <Link to="/login" className="btn-nav">
                {t('signin')}
              </Link>
            )}

            {dashboardMatch ? (
              <>
                <Link to="/" className="btn-nav">
                  {t('home')}
                </Link>

                {isMobile && (
                  <Link
                    className="btn-nav"
                    onClick={(e) => {
                      e.preventDefault()
                      setExpanded(false)
                      launchTour()
                    }}
                  >
                    {t('dashboard_tour_btn')}
                  </Link>
                )}
              </>
            ) : (
              <Link to="/dashboard" className="btn-nav">
                {t('dashboard')}
              </Link>
            )}
            <a
              href={HELP_DESK['main'][lang]}
              target="_blank"
              className="btn-nav"
              rel="noreferrer"
            >
              {t('help')}
            </a>
            <StyledDropdown
              options={langs}
              defaultValueId={lang}
              onChange={(option) => changeLang(option.id)}
            />
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      {!pathname.includes('dashboard') && (
        <div className="topbar-bottom" style={scrollY}>
          {!isMobile && (
            <a
              href="/"
              className={
                window.location.pathname === '/' ? 'btn-nav active' : 'btn-nav'
              }
            >
              {t('home')}
            </a>
          )}
          <a
            href="/your-book"
            className={
              window.location.pathname === '/your-book'
                ? 'btn-nav active'
                : 'btn-nav'
            }
          >
            {t('yourbook')}
          </a>
          <a
            href="/how-it-works"
            className={
              window.location.pathname === '/how-it-works'
                ? 'btn-nav active'
                : 'btn-nav'
            }
          >
            {t('howitworks')}
          </a>
          <a
            href="/pricing"
            className={
              window.location.pathname === '/pricing'
                ? 'btn-nav active'
                : 'btn-nav'
            }
          >
            {t('pricing')}
          </a>
          <a
            href="/get-started"
            className={
              window.location.pathname === '/get-started'
                ? 'btn-nav active'
                : 'btn-nav'
            }
          >
            {t('getstarted')}
          </a>
        </div>
      )}
    </TopbarContainer>
  )
}

export default Topbar
